// Booking Configuration
export const BOOKING_CONFIG = {
  // Main toggle for booking functionality
  enableBooking: true,
  
  // Booking display settings
  display: {
    showInServices: true,       // Show booking buttons in services section
    showInDoctorSection: true,  // Show booking button in doctor section
    showInHeader: true,         // Show booking CTA in header
    showInHero: true,           // Show booking button in hero section
    showInContact: true,        // Show booking option in contact section
    showPhoneBooking: true,     // Show phone booking option
    showOnlineBooking: true,    // Show online booking option
    showEmergencyBooking: true  // Show emergency booking option
  },
  
  // Booking button customization
  buttonText: {
    primary: "Book Appointment",
    secondary: "Schedule Consultation",
    emergency: "Emergency Consultation",
    phone: "Call to Book"
  },
  
  // Alternative content when booking is disabled
  alternative: {
    showMessage: true,
    message: "Online booking is currently unavailable. Please contact us directly to schedule an appointment.",
    showContactInfo: true,
    redirectToContact: true
  }
};

// Helper function to check if booking is enabled
export const isBookingEnabled = () => {
  return BOOKING_CONFIG.enableBooking;
};

// Helper function to check if booking should show in specific locations
export const shouldShowBookingIn = (location) => {
  if (!BOOKING_CONFIG.enableBooking) return false;
  return BOOKING_CONFIG.display[`showIn${location}`] || false;
};

// Helper function to check if specific booking features should show
export const isBookingFeatureEnabled = (feature) => {
  if (!BOOKING_CONFIG.enableBooking) return false;
  return BOOKING_CONFIG.display[feature] || false;
};

// Helper function to get booking button text
export const getBookingButtonText = (type = 'primary') => {
  return BOOKING_CONFIG.buttonText[type] || BOOKING_CONFIG.buttonText.primary;
};

// Helper function to get alternative message when booking is disabled
export const getBookingAlternativeMessage = () => {
  return BOOKING_CONFIG.alternative;
};

// Helper function to check if any booking option should be shown
export const shouldShowAnyBooking = () => {
  if (!BOOKING_CONFIG.enableBooking) return false;
  const displaySettings = BOOKING_CONFIG.display;
  return Object.keys(displaySettings).some(key => displaySettings[key]);
};
